export default {
	orderwebsitepage: '/site/orderwebsitepage', // 网建订单列表
	orderwebsiteinfo: '/site/orderwebsiteinfo/{orderId}', //网建订单头部信息
	websitelist: '/node/websitelist', //网建订单详情
	compileWebsiteUrl: '/node/website_preview_url/', // 编辑网站预览地址
	getNodeList: '/node/selectwbnodebybindpage', //获取节点列表
	orderQuery: '/service/param_name', //订单查询
	bindNode: '/site/bindwebsitenode',
	unbindNode: '/site/untiewebsitenode/', //解绑节点
	siteUpload: '/site/uploadfiletonfs', //上传
	release: '/site/releasewebsite', //发布,
	getUploadInfo: '/site/obtainwebuploadinfo', //上传进度
	editWebsite: '/site/updatewebsite', //修改记录数据
	websiteList: '/order/website/orderwebsitelist', //网建列表
	updateDomain: '/site/bindwebsitenode', //更新节点
	getSiteDetail: '/site/websitenodeinfo/', //获取详情
	getAliDomainList: '/site/getaliyundomian/', //获取阿里云域名信息
	getSiteList: '/site/unboundwebsitelist', //获取未绑定的网站列表
	fileUpload: process.env.VUE_APP_DOMAIN + '/file/fileupload',
	bindEmail: '/site/updateservicesitebyemail',
	bindGaAccount: '/sites/monitors/ga/account/bind/{id}', // 绑定GA账号
	bindGTMAccount: '/sites/monitors/gtm/container/bind/{id}', // 绑定GA账号
	bindBdAccount: '/site/bindbaidusite/', // 绑定百度网站API

	getDetail: '/sites/monitors/{id}', // 获取GA绑定详情
	setCode: '/sites/monitors/gtm/enquiries-traced-tag/{id}', // 设置代码
	visitantIdentify: '/sites/monitors/bindleadfeeder', // 访客识别绑定
	unbindleadfeeder: '/sites/monitors/unbindleadfeeder', // 访客识别解绑
	languageList: '/sites/monitors/languages/list', // 语种列表
	websiteCode: '/sites/monitors/languages/gtm-install/{id}', //网站GTM代码安装
	getCheckgroup: '/visitor/checkgroup', // 查看访客自定义分组

	addCdnDomain: '/site/addcdndomain',
	refreshCdnDomain: '/site/refreshcdndomaincache',
	refreshCdnStatus: '/site/refreshcdndomainstatus',
	getCreatewebtkd: '/websitetask/createwebtkd', //创建爬取任务
	googlereports: '/ads/report', // 谷歌报告
	googlederive: '/ads/report/export', // 下载谷歌报告
	getFormInquiryList: '/inquiry/gainquirypage',
	// 询盘邮箱
	addAnalysisMail: '/site/addanalysis', //新增询盘邮箱解析记录
	getDomainlist: '/xdomain/domainlist', //获取渠道账号列表
	getInquiryMail: '/site/inquiryemailinfo/{serviceSiteId}', //获取询盘邮箱信息
	analysisTxt: '/xdomain/txtanalysis', //txt解析
	// analysisTxt: '/site/txtanalysis', //txt解析
	emailAnalysis: '/site/emailanalysis', //邮箱解析
	emailUnbind: '/site/emailunbind', //邮箱解绑
	searchTermsDownload: '/admin/search_term/report', // 下载搜索词报告
	advertisingSeries: '/admin/search_term/campaign_list', // 广告系列
	advertisingGroup: '/admin/search_term/ad_group_list', // 广告组
	searchTermsHistoryList: '/admin/search_term/history_list', // 提交列表
	advertisingSubmitSeries: '/admin/search_term/{service_id}/campaign_list', // 已提交广告系列
	advertisingSubmitGroup: '/admin/search_term/{service_id}/ad_group_list', // 已提交广告组
	advertisingSubmitDownload: '/admin/search_term/mark_report', // 已提交广告组
	// 网站数据-网站数据模块接口
	// GA
	getGaMainReport: '/site/report/data', // 网站数据5
	getGaChannelReport: '/site/report/channel', // 渠道分析6
	getGaMapReport: '/site/report/terrain', // 地域分析3
	getGaSiteReport: '/site/report/page', // 网页报告4
	getGaTimeReport: '/site/report/during', // 时段分析2
	// BaiDu
	getBdMainReport: '/tongji/trendtime/', // 网站数据
	getBdChannelReport: '/tongji/sourceall/', // 渠道分析
	getBdMapReport: '/tongji/visitdistrict/', // 地域分析
	getBdSiteReport: '/tongji/visittoppage/', // 网页报告
	//点击跟踪
	//GA&ADS关联
	associate: '/sites/monitors/ga/associate/{id}',
	//创建GA目标
	goal: '/sites/monitors/ga/goal/{id}',
	//GTM容器配置
	tags: '/sites/monitors/gtm/tags/{id}',
	// GTM-点击跟踪一键配置
	gtmTraceConfig: '/sites/monitors/gtm/click-on-tracking/{id}',
	//再营销---GTM容器配置
	tagsMarket: '/sites/monitors/gtm/tags-market',
	//再营销---容器发布
	tagsMarketPublish: '/sites/monitors/gtm/tags-market-publish/{id}',
	//gtm详情
	gtmDetails: '/sites/monitors/gtm/details/{id}',

	addEnhancedConversions: '/sites/monitors/gtm/add-enhanced-conversions/{id}', // GTM-开启增强型潜在客户转化一键配置
	removeEnhancedConversions: '/sites/monitors/gtm/remove-enhanced-conversions/{id}', // GTM-关闭增强型潜在客户转化一键配置

	addGoogleTagGateway: '/sites/monitors/gtm/add-google-tag-gateway/{id}', // 开启Google代码网关一键配置
	removeGoogleTagGateway: '/sites/monitors/gtm/remove-google-tag-gateway/{id}', // 关闭Google代码网关一键配置

	// gsc
	gscList: '/admin/forword/site/gsc/{id}', // GSC域名列表
	addGsc: '/admin/forword/site/gsc', // GSC账号授权

	//获取服务单的转化id
	getConversionId: '/sites/monitors/gtm/conversion/{id}',
	setindustry: '/sites/monitors/industry/{id}',
	campaign_device: '/ads/report/campaign_device', //设备按广告系列细分
	campaign_deviceExport: '/ads/report/campaign_device/export', //设备按广告系列细分导出
};
